module.exports = __webpack_public_path__ + "img/logo_seistetos.8e4f7e9a.svg";